// Lightweight — exports only the list of valid app icon codes and the
// derived type. Kept separate from AppIcons.ts so consumers that just
// need to validate a name don't transitively pull FontAwesome SVG data.
export const APP_ICON_CODES = [
    'add',
    'angle-down',
    'angle-left',
    'angle-right',
    'angle-up',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-right-long',
    'arrow-up',
    'basket',
    'bed',
    'calendar',
    'check',
    'check-circle',
    'child-reaching',
    'clock',
    'close',
    'copy',
    'credit-card',
    'exclamation-triangle',
    'globe',
    'info-circle',
    'magnify',
    'minus',
    'money-bill-wave',
    'moon',
    'pencil',
    'refresh',
    'shield-check',
    'sliders',
    'star',
    'tag',
    'trash-can',
    'university',
    'user',
    'users',
    'warn-circle',
];
